
export const removeBase64Prefix = (base64: string | null | undefined): string => {
    if (!base64) return '';
    const splitArr = base64.split(';base64,');
    const base64Result = splitArr.length > 1 ? splitArr[splitArr.length - 1] : base64;
    return base64Result;
};